module.exports = __webpack_public_path__ + "static/media/encerrada-shell-na-caixa.93e49565.jpg";